import React from "react";

const TermsCondition = () => {
    return (
        <div className="container d-flex justify-content-center align-items-center my-5">
            <div className="w-100" style={{ maxWidth: "900px" }}>
                <h2 className="text-center mb-4 fw-bold">
                    Young Inspirators Network Prime Membership - Terms & Conditions
                </h2>

                <div
                    style={{
                        background: "#f9f9f9",
                        padding: "25px",
                        borderRadius: "8px",
                        lineHeight: "1.8",
                    }}
                >
                    <ol className="mb-0">
                        <li>
                            The prime membership fee is ₹999 and is valid for one year only
                            from the date of registration.
                        </li>
                        <li>
                            Once registered, the prime membership fee is non-refundable and
                            not transferable.
                        </li>
                        <li>
                            The Young Inspirators Network Prime Membership Kit (Bag + Water Bottle + Goodies) can be collected from the YIN representative after successful registration.
                        </li>
                        <li>
                            Birthday coupons are valid only during the period specified on the
                            coupon.
                        </li>
                        <li>
                            Priority entry to Young Inspirators Network events and programs
                            will be provided, subject to seating capacity and availability.
                        </li>
                        <li>
                            Access to prime membership online courses is strictly for the
                            registered member and cannot be transferred to others.
                        </li>
                        <li>
                            Prime Members must download and register on the Young Inspirators
                            Network App to avail all benefits.
                        </li>
                        <li>
                            Young Inspirators Network is not responsible for lost, stolen, or
                            damaged prime membership kits or coupons once delivered.
                        </li>
                        <li>
                            Prime Membership benefits will remain valid only during the
                            membership term and will automatically expire after one year.
                        </li>
                        <li>
                            Misuse of prime membership privileges may result in cancellation
                            of membership without refund.
                        </li>
                        <li>
                            All prime membership benefits and privileges are subject to change
                            at the discretion of the Young Inspirators Network.
                        </li>
                        <li>
                            The final decision on all matters related to the prime membership
                            rests solely with the Young Inspirators Network.
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    );
};

export default TermsCondition;
